import { truncate } from "lodash";
import moment from "moment";
import React from "react";
import VendorAvatar from "./VendorAvatar";

type SpaceTaskCardProps = {
    title: string;
    description: string;
    startDate: string;
    endDate?: string;
    createdBy: any;
    typeIcon?: React.ReactNode;
    typeText?: string;
    typeColor?: string;
    imageSrc?: string;
    onClick?: () => void;
};
const SpaceTaskCard = ({
    title,
    description,
    startDate,
    endDate,
    createdBy,
    typeIcon,
    typeText,
    typeColor,
    imageSrc,
    onClick,
}: SpaceTaskCardProps) => {
    return (
        <div
            className="bg-white rounded-lg border border-slate-200 shadow-[0px_4px_16px_0px_rgba(0,0,0,0.04)] font-rocGroteskMedium cursor-pointer pt-3 overflow-x-hidden"
            onClick={onClick}
        >
            <div className="px-3">
                <p className="text-g-75 text-sm mb-1">{title}</p>
                <p className="text-slate-500 text-[13px] mb-2">
                    {truncate(description, { length: 70 })}
                </p>
                <div className="w-[270px] flex items-center border border-slate-200 rounded-[6px]  px-[6px] shadow-[0px_1px_4px_0px_rgba(0,0,0,0.05)] justify-sta mb-2">
                    <div
                        className={`flex  py-[4px] ${
                            endDate ? "pr-2 border-r border-r-slate-200" : ""
                        }`}
                    >
                        <p className="text-slate-500 text-[13px]">
                            {moment(startDate).format("DD MMM YYYY")}
                        </p>
                        <i className="ri-arrow-down-s-line text-sm text-slate-400 px-1"></i>
                    </div>
                    {endDate && <i className="ri-arrow-right-line text-sm text-slate-400 px-2"></i>}
                    {endDate && (
                        <div className="flex border-l border-l-slate-200 pl-2 py-[4px]">
                            <p className="text-slate-500 text-[13px]">
                                {moment(endDate).format("DD MMM YYYY")}
                            </p>
                            <i className="ri-arrow-down-s-line text-sm text-slate-400 px-1"></i>
                        </div>
                    )}
                </div>
            </div>

            <div className="border-t border-t-slate-200 p-3 flex items-center justify-between gap-2">
                <div className="flex items-center gap-2">
                    <VendorAvatar size={20} name={createdBy} imageSrc={imageSrc} />
                    <p className="text-slate-500 text-[13px] text-xs">{createdBy}</p>
                </div>
                <div className="flex items-center gap-2">
                    {typeIcon && typeIcon}
                    {typeText && (
                        <p
                            className="text-slate-500 text-[13px] text-xs"
                            style={{ color: typeColor }}
                        >
                            {typeText}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SpaceTaskCard;
